export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10305.e274932e.jpg";